import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = ['!CALL_URL', '!FETCH_CITIES', '!FETCH_EXCHANGE_RATE'] as const

export default serviceActionsGenerator('common', actionTypes)
